import Page from 'classes/Page'
import SingleProductFn from './functions'

export default class SingleProduct extends Page {
  constructor () {
    super({
      id: 'singleProduct',
      element: '.singleProduct',
      elements: {}
    })

    this.scrollToPurchase = document.getElementById("purchaseItem");

    /** Check if is page **/
    if (document.getElementsByClassName(this.id).length > 0) {

      this.scrollPurchase();
      this.createInteractions();

    }

  }

  scrollPurchase(){
    window.addEventListener('scroll', function (event) {

      var top_of_element = jQuery(".single_wine_info").offset().top - 600;
      var top_of_screen = jQuery(window).scrollTop();

      if (top_of_screen > top_of_element){
        jQuery('#purchaseItem').addClass('visible');
      }
      else{
        jQuery('#purchaseItem').removeClass('visible');
      }

    }, true);
  }

  scrollToPurchaseItem = () => {
    window.scrollTo(0, 0);
  }

  createInteractions = () => {;
    this.scrollToPurchase.addEventListener('click', this.scrollToPurchaseItem);
  }

  pageFn() {
    return new SingleProductFn()
  }



}
